import React, {useContext, useState} from "react";
import axios from "axios";
import {downloadDoc, visualizzaAnteprimaFile} from "../../../../../utility/common";
import {LoaderContext} from "../../../../../context/LoaderContext";
import TabellaCertDocumentiFirmatiView from "./TabellaCertDocumentiFirmatiView";

export default function TabellaCertDocumentiFirmatiController({
                                                                  documentiFirmati,
                                                                  totDocumentiFirmati,
                                                                  handlerUpdateCertificati,
                                                              }) {

    const [showMsg, setShowMsg] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function downloadDocFirmato(row, download) {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${row.id_certificato}/documento-firmato/?download=1`).then((response) => {
            endChiamata();
            if (response.data.result == -1) {
                setModalMsg(response.data.description)
                setShowMsg(true)
            } else {
                let resp = response.data.data;
                if (resp) {
                    if (download === true) {
                        downloadDoc(resp)
                    } else {
                        const contentType = resp.content_type;
                        const base64Data = resp.contenuto;

                        visualizzaAnteprimaFile(base64Data, contentType);
                    }
                }
            }
        });
    }

    function inviaEmailDocumentoFirmatoCert(idCertificato) {
        startChiamata()
        axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/documento-firmato/email`).then((response) => {
            setModalMsg(response.data.description)
            setShowMsg(true)
            if (response.data.result == '0') {
                handlerUpdateCertificati();
            }
            endChiamata()
        });
    }

    return (
        <TabellaCertDocumentiFirmatiView
            documentiFirmati={documentiFirmati}
            downloadDocFirmato={downloadDocFirmato}
            setShowMsg={setShowMsg}
            totDocumentiFirmati={totDocumentiFirmati}
            showMsg={showMsg}
            modalMsg={modalMsg}
            inviaEmailDocumentoFirmatoCert={inviaEmailDocumentoFirmatoCert}
        />
    );

}